// Offers & Payments  form config

export const litigationInfoFields = [
    {
        key: 'litigation-information',
        name: 'Litigation Information',
        fields: [
            {
                name: 'proceedings_received',
                label: 'Proceedings Received?',
                type: 'text',
                validation: {}
            },
            {
                name: 'judgment_received',
                label: 'Judgment Received?',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'reason_for_judgment',
                label: 'Reason For Judgment?',
                type: 'text',
                validation: {}
            },
            {
                name: 'reason_for_litigation',
                label: 'Reason for Litigation',
                type: 'text',
                validation: {}
            },
            {
                name: 'avoidable_litigation',
                label: 'Avoidable Litigation?',
                type: 'text',
                validation: {}
            },
            {
                name: 'date_of_court_proceedings',
                label: 'Date of Court Proceedings',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_court_proceedings_received',
                label: 'Date Court Proceedings Received',
                type: 'date',
                validation: {}
            },
            {
                name: 'court_where_proceedings_received',
                label: 'Court Where Proceedings Received',
                type: 'text',
                validation: {}
            },
            {
                name: 'court_where_proceedings_issued',
                label: 'Court Where Proceedings Issued',
                type: 'text',
                validation: {}
            },
            {
                name: 'instruct_legal_supply',
                label: 'Instruct Legal Supply',
                type: 'text',
                validation: {}
            },
            {
                name: 'date_legal_supply_instructed',
                label: 'Date Legal Supply Instructed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_legal_supply_acknowledged',
                label: 'Date Legal Supply Acknowledged',
                type: 'date',
                validation: {}
            },
            {
                name: 'legal_supplier_instructed',
                label: 'Legal Supplier Instructed',
                type: 'text',
                validation: {}
            },
            {
                name: 'legal_supplier_ref',
                label: 'Legal Supplier Reference',
                type: 'text',
                validation: {}
            },
            {
                name: 'legal_supplier_handler',
                label: 'Legal Supplier Handler',
                type: 'text',
                validation: {}
            },
            {
                name: 'legal_supplier_handler_contact_nb',
                label: 'Legal Supplier Handler Contact Number',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'phoneNumber'}]
            },
            {
                name: 'legal_supplier_handler_email_address',
                label: 'Legal Supplier Handler Email Address',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'email' }]
            }
        ]
    },
    {
        key: 'litigation-handling',
        name: 'Litigation Handling',
        fields: [
            {
                name: 'date_aos_required',
                label: 'Date AOS Required',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_aos_filed',
                label: 'Date AOS Filed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_defence_required',
                label: 'Date Defence Required',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_defence_filed',
                label: 'Date Defence Filed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_disclosure_required',
                label: 'Date Disclosure Required',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_disclosure_filed',
                label: 'Date Disclosure Filed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_witness_statements_required',
                label: 'Date Witness Statements Required',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_witness_statements_filed',
                label: 'Date Witness Statements Issued',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_counsel_booked',
                label: 'Date Counsel Booked',
                type: 'date',
                validation: {}
            },
            {
                name: 'counsel_chambers_booked',
                label: 'Counsel Chambers Booked',
                type: 'text',
                validation: {}
            },
            {
                name: 'name_of_counsel_booked',
                label: 'Name of Counsel Booked',
                type: 'text',
                validation: {}
            },
            {
                name: 'contact_nb_of_counsel_booked',
                label: 'Contact Number of Counsel Booked',
                type: 'text',
                validation: {},
                modalValidation: [{name: 'phoneNumber'}]
            },
            {
                name: 'email_address_of_counsel_booked',
                label: 'Email Address of Counsel Booked',
                type: 'text',
                validation: {},
                modalValidation: [{ name: 'email' }]
            },
            {
                name: 'date_of_trial',
                label: 'Date of Trial',
                type: 'date',
                validation: {}
            },
            {
                name: 'litigation_outcome',
                label: 'Litigation Outcome',
                type: 'text',
                validation: {}
            }
        ]
    }
];
